import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02853718"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "list-detail-drawer__list-section__controls" };
const _hoisted_2 = { class: "duplicate-component-drawer-toolbar" };
import { computed } from "vue";
import SearchBar from "../../ui/search/SearchBar.vue";
import ComponentDuplicationCandidateFilterMenu from "./ComponentDuplicationCandidateFilterMenu.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentCandidateToolbar',
    props: {
        search: {},
        selectedClientIds: {},
        availableClientIds: {},
        componentGranters: {},
        showAll: { type: Boolean },
        isLoading: { type: Boolean }
    },
    emits: ["update:search", "update:selectedClientIds", "update:showAll"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const searchProxy = computed({
            get: () => props.search,
            set: (value) => emit("update:search", value),
        });
        const selectedClientIdsProxy = computed({
            get: () => props.selectedClientIds,
            set: (value) => emit("update:selectedClientIds", value),
        });
        const showAllProxy = computed({
            get: () => props.showAll,
            set: (value) => emit("update:showAll", value),
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(SearchBar, {
                        class: "search-bar",
                        search: searchProxy.value,
                        "onUpdate:search": _cache[0] || (_cache[0] = ($event) => ((searchProxy).value = $event))
                    }, null, 8 /* PROPS */, ["search"]),
                    _createVNode(ComponentDuplicationCandidateFilterMenu, {
                        "available-client-ids": _ctx.availableClientIds,
                        "component-granters": _ctx.componentGranters,
                        "selected-client-ids": selectedClientIdsProxy.value,
                        "onUpdate:selectedClientIds": _cache[1] || (_cache[1] = ($event) => ((selectedClientIdsProxy).value = $event)),
                        "show-all": showAllProxy.value,
                        "onUpdate:showAll": _cache[2] || (_cache[2] = ($event) => ((showAllProxy).value = $event)),
                        "is-loading": _ctx.isLoading
                    }, null, 8 /* PROPS */, ["available-client-ids", "component-granters", "selected-client-ids", "show-all", "is-loading"])
                ])
            ]));
        };
    }
});
